import React, { useState } from "react";
import mainStyle from "../../style/Main.module.css";
import MainLayout from "../../layouts/MainLayout";
import PageInputStyle from "../../components/ui/input/PagesInput/PagesInput.module.css";
import Button from "../../components/ui/buttons/Button";
import Loader from "../../components/ui/Loader/Loader";
import Style from "../../style/Pages/User&RoleCreateUpdate.module.css";
import Select from "react-select";
import { CreateAcessCat } from "../../hooks/useUser&role";
import { useAccessUser, useFetchUserCompany } from "../../hooks/useCommonHooks";
import { MultiSelect } from "react-multi-select-component";

const AddUserAndRole = () => {
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [selectedCompanies, setSelectedCompanies] = useState([]); // <-- NEW state

  const { formData, loading, error, setFormData, setError, handleSubmit } =
    CreateAcessCat(setSelectedCompanyId);
  const users = useAccessUser();
  const companyList = useFetchUserCompany(selectedCompanyId);

  const companyOptions = companyList.map((company) => ({
    label: company.company_name,
    value: company.id,
  }));

  const handleCompanyChange = (options) => {
    setSelectedCompanies(options || []); // store multi-selected companies

    setFormData((prev) => ({
      ...prev,
      access_company: options.map((o) => o.value), // store company IDs
    }));

    setError((prev) => ({ ...prev, access_company: "" }));
  };
  const handleUserChange = (option) => {
    if (!option) {
      setError((prev) => ({ ...prev, register: "User is required" }));
      return;
    }
    setSelectedCompanyId(option.value); // fetch new companies for this user
    setSelectedCompanies([]); // clear old companies

    setFormData((prev) => ({
      ...prev,
      register: option.value,
      access_company: [], // reset companies
    }));
    setError((prev) => ({ ...prev, register: "" }));
  };

  React.useEffect(() => {
    if (
      !formData.access_details ||
      Object.keys(formData.access_details).length === 0
    ) {
      setFormData((prev) => ({
        ...prev,
        access_details: {
          user: {
            view: false,
            add: false,
            edit: false,
            active_deactive: false,
          },
          group: {
            view: false,
            add: false,
            edit: false,
            active_deactive: false,
          },
          channel: {
            view: false,
            add: false,
            edit: false,
            active_deactive: false,
          },
          // company: {
          //   view: false,
          //   add: false,
          //   edit: false,
          //   active_deactive: false,
          // },
        },
      }));
    }
  }, [formData.access_details, setFormData]);

  const handlePermissionChange = (category, permissionType) => {
    const updatedCategory = {
      ...formData.access_details[category],
      [permissionType]: !formData.access_details[category][permissionType],
    };

    // Rule: If add/edit/active_deactive is true, view must be true
    if (permissionType !== "view" && updatedCategory[permissionType] === true) {
      updatedCategory.view = true;
    }

    // Rule: If all (add/edit/active_deactive) are false, view can be toggled independently
    if (
      permissionType === "view" &&
      updatedCategory.view === false &&
      (updatedCategory.add ||
        updatedCategory.edit ||
        updatedCategory.active_deactive)
    ) {
      // Prevent turning off view if other permissions are enabled
      updatedCategory.view = true;
    }

    const updatedPermissions = {
      ...formData.access_details,
      [category]: updatedCategory,
    };

    // Clear error if at least one permission is selected
    const hasPermissions = Object.values(updatedPermissions).some((category) =>
      Object.values(category).some((permission) => permission)
    );

    if (hasPermissions && error.access_details) {
      setError((prev) => {
        const newErrors = { ...prev };
        delete newErrors.access_details;
        return newErrors;
      });
    }

    setFormData((prev) => ({
      ...prev,
      access_details: updatedPermissions,
    }));
  };

  // Generate user options only if users is defined
  const userOptions =
    users?.map((user) => ({
      label: user.name,
      value: user.id,
    })) || [];

  return (
    <MainLayout>
      <div className={mainStyle.mainPageHeader}>
        <div>
          <p className={mainStyle.mainHeading}>Add User Access:</p>
        </div>
        <div className={mainStyle.mainPageButtons}></div>
      </div>

      <div className={mainStyle.mainContentView} style={{ height: "84%" }}>
        <div className={mainStyle.mainContentViewsb}>
          <div className={mainStyle.mainContentCard}>
            <p className={mainStyle.aboutPageContent}>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Welcome to our
              Authorized access will be granted only after the company is
              selected. The Access Category — covering the User, Group, and
              Channel modules with permissions for View, Add, Edit, and
              Active/Deactive — can be configured only by the admin. These
              permissions determine what actions the user can perform within
              each module and must be properly set to ensure appropriate control
              and security.
            </p>
            <div className={mainStyle.mainContentForm}>
              <div className={mainStyle.mainContentFormSplit}>
                <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    User<span className={mainStyle.mantitory}>*</span>
                  </label>
                  <Select
                    className={mainStyle.selectBoxPage}
                    options={userOptions}
                    value={
                      userOptions.find(
                        (option) => option.value === formData.register
                      ) || null
                    }
                    onChange={handleUserChange}
                    isClearable={false}
                  />
                  {error.register && (
                    <span className={mainStyle.errorMsg}>{error.register}</span>
                  )}
                </div>
                <div className={mainStyle.mainInputDiv}>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Company<span className={mainStyle.mantitory}>*</span>
                  </label>
                  {/* <Select
                    className={mainStyle.selectBoxPage}
                    options={companyOptions}
                    value={companyOptions.find(
                      (option) => option.value === formData.access_company
                    )}
                    onChange={handleCompanyChange}
                    isClearable={false} // This removes the clear symbol
                  /> */}

                  <MultiSelect
                    options={companyOptions}
                    value={selectedCompanies} // <-- use selectedCompanies state
                    onChange={handleCompanyChange}
                    labelledBy="Select Companies"
                    className={mainStyle.mutiSelectDropDown}
                    disabled={!formData.register} // <-- disable until user is selected
                    overrideStrings={{
                      allItemsAreSelected: "All companies selected",
                      selectSomeItems: "Select Companies",
                    }}
                  />
                  {error.access_company && (
                    <span className={mainStyle.errorMsg}>
                      {error.access_company}
                    </span>
                  )}
                </div>
              </div>
              <p className={mainStyle.contentGuideOrd}>
                Note : Authorized access will be granted to the person.
              </p>
              <div>
                <div>
                  <label htmlFor="text" className={PageInputStyle.label}>
                    Access Category
                    <span className={mainStyle.mantitory}>*</span>
                  </label>
                  {error.access_details && (
                    <span className={mainStyle.errorMsg}>
                      {error.access_details}
                    </span>
                  )}
                </div>
                <div>
                  <table className={Style.permissionsTable}>
                    <thead>
                      <tr>
                        <th>Category</th>
                        <th>View</th>
                        <th>Add</th>
                        <th>Edit</th>
                        <th>Active/Deactive</th>
                      </tr>
                    </thead>
                    <tbody>
                      {["user", "group", "channel"].map((category) => (
                        <tr key={category}>
                          <td>
                            {category.charAt(0).toUpperCase() +
                              category.slice(1)}
                          </td>
                          <td>
                            <label className={Style.toggleSwitch}>
                              <input
                                type="checkbox"
                                checked={
                                  formData.access_details[category]?.view ||
                                  false
                                }
                                onChange={() =>
                                  handlePermissionChange(category, "view")
                                }
                              />
                              <span className={Style.toggleSlider}></span>
                            </label>
                          </td>
                          <td>
                            <label className={Style.toggleSwitch}>
                              <input
                                type="checkbox"
                                checked={
                                  formData.access_details[category]?.add ||
                                  false
                                }
                                onChange={() =>
                                  handlePermissionChange(category, "add")
                                }
                              />
                              <span className={Style.toggleSlider}></span>
                            </label>
                          </td>
                          <td>
                            <label className={Style.toggleSwitch}>
                              <input
                                type="checkbox"
                                checked={
                                  formData.access_details[category]?.edit ||
                                  false
                                }
                                onChange={() =>
                                  handlePermissionChange(category, "edit")
                                }
                              />
                              <span className={Style.toggleSlider}></span>
                            </label>
                          </td>
                          <td>
                            <label className={Style.toggleSwitch}>
                              <input
                                type="checkbox"
                                checked={
                                  formData.access_details[category]
                                    ?.active_deactive || false
                                }
                                onChange={() =>
                                  handlePermissionChange(
                                    category,
                                    "active_deactive"
                                  )
                                }
                              />
                              <span className={Style.toggleSlider}></span>
                            </label>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className={mainStyle.mainContentFormSplit}>
                <div
                  className={mainStyle.mainButtonDiv}
                  style={{ width: "100%" }}
                >
                  <Button onClick={handleSubmit}>
                    {loading ? <Loader /> : "Invite"}
                  </Button>
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddUserAndRole;
